const cbs = [];

export const addLoginHandlers = function () {
    const args = Array.prototype.slice.call(arguments);
    cbs.push(
        ...args.reduce((acc, item) => {
            if (Array.isArray(item)) {
                acc.push(...item);
            } else {
                acc.push(item);
            }
            return acc;
        }, [])
    );
};

export const fireLoginHandlers = function (arg) {
    cbs.forEach(func => func(arg));
};

export const getLoginHandlers = function () {
    return [...cbs];
};

export const dumpHandlers = function () {
    cbs.length = 0;
};

const RESET_UPDATE_USER_STATE = 'resetUpdateUserState';
const FORCE_FAVORITE_REFETCH = 'forceFavoriteRefetch';
const SEND_CHAT_MESSAGE = 'sendChatMessage';
const SET_HAS_PAGE_REFETCHED = 'setHasPageFetched';

const namedHandlers = {
    [RESET_UPDATE_USER_STATE]: () => null,
    [FORCE_FAVORITE_REFETCH]: [],
    [SEND_CHAT_MESSAGE]: () => null,
    [SET_HAS_PAGE_REFETCHED]: () => null,
};

export const initSetHasPageRefetched = fn => {
    namedHandlers[SET_HAS_PAGE_REFETCHED] = fn;
};

export const setHasPageRefetched = () => {
    if (typeof namedHandlers[SET_HAS_PAGE_REFETCHED] === 'function') {
        namedHandlers[SET_HAS_PAGE_REFETCHED]();
    }
};

export const initSendChatMessageOnPageRefetch = fn => {
    namedHandlers[SEND_CHAT_MESSAGE] = fn;
};

export const sendChatMessageOnPageRefetch = () => {
    if (typeof namedHandlers[SEND_CHAT_MESSAGE] === 'function') {
        namedHandlers[SEND_CHAT_MESSAGE]();
    }
};

export const initResetUpdateUserState = fn => {
    namedHandlers[RESET_UPDATE_USER_STATE] = fn;
};

export const resetUpdateUserState = () => {
    if (typeof namedHandlers[RESET_UPDATE_USER_STATE] === 'function') {
        namedHandlers[RESET_UPDATE_USER_STATE]();
    }
};

export const addForceFavoriteRefetchHandler = fn => {
    namedHandlers[FORCE_FAVORITE_REFETCH] = [fn, ...namedHandlers[FORCE_FAVORITE_REFETCH]];
};

export const fireForceFavoriteRefetchHandlers = () => {
    namedHandlers[FORCE_FAVORITE_REFETCH].forEach(fn => {
        if (typeof fn === 'function') {
            fn();
        }
    });
};
